// calculate 2 lowest prices for each search result
const getSinglePrice = (private_office: any[], duration: string) => {
  const result = private_office.reduce((minPriceObj, currentObj) => {
    // If the current object has a lower price and the same duration_metric, update minPriceObj
    if (
      currentObj.duration_metric === duration
      && (minPriceObj === null || currentObj.price < minPriceObj.price)
    ) {
      return {
        name: currentObj.name,
        currency_code: currentObj.currency_code,
        price: currentObj.price,
        duration_metric: currentObj.duration_metric,
      };
    }

    return minPriceObj;
  }, null);

  return result;
};

export const getMembershipPrices = (memberships: any, checkedState: any = {}, currentDuration: string = 'month') => {
  const names = {
    private_offices: 'Private Office',
    hot_desks: 'Coworking Space',
    dedicated_desks: 'Coworking Space',
    meeting_rooms: 'Meeting rooms',
    virtual_offices: 'Virtual Office',
  };

  const monthlyPrices = ['private_offices', 'hot_desks', 'dedicated_desks', 'virtual_offices', 'airport_lounges']
    .map((key) => {
      if (memberships && memberships[key]) {
        if (Array.isArray(memberships[key])) {
          const monthly = getSinglePrice(memberships[key], currentDuration);
          if (monthly) {
            return { ...monthly, name: names[key as keyof typeof names] };
          }
        } else if (key === 'virtual_offices' && Object.prototype.hasOwnProperty.call(memberships[key], 'price') && currentDuration == 'month') {
          return { ...memberships[key], name: names[key], duration_metric: 'month' };
        }
      }

      return null;
    })
    .filter((item) => item !== null);

  const uniqueMonthlyPrices = monthlyPrices.reduce((uniquePrices, currentPrice) => {
    const existingIndex = uniquePrices.findIndex((item:any) => item.name === currentPrice.name);

    if (existingIndex === -1) {
      // If the name doesn't exist yet, add the current price object to the array
      uniquePrices.push(currentPrice);
    } else if (currentPrice.price < uniquePrices[existingIndex].price) {
      // If the current price is lower than the existing one, update the existing object
      uniquePrices[existingIndex] = currentPrice;
    }

    return uniquePrices;
  }, []);

  return uniqueMonthlyPrices;
};

export const scrollToTop = (selector: string) => {
  // Scroll the view to the top
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });

  // Scroll the specific element to the top
  const container = document.querySelector(selector);
  if (container) {
    container.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}

export function parseQueryString(queryString: string, switches: any) {
  const queryArray = queryString.split(',');

  const queryObj = queryArray.reduce((acc, currentValue) => {
    const newKey = Object.keys(switches).find((key) => switches[key] === currentValue);
    if (newKey) {
      acc[newKey] = true;
    }
    return acc;
  }, {} as Record<string, boolean>);

  return {
    checkedState: queryObj,
    activeKeysCount: Object.keys(queryObj).length,
    activeResources: queryArray,
  };
}

export const getMaxWorkspaceCount = (checkedState: Record<string, any>, spacesCount: Record<string, any>, anyWorkspaceChecked: boolean) => {
  const maxWorkspaceCount = Object.entries(checkedState).filter(([, value]) => value);
  let maxValue = 0;
  if (anyWorkspaceChecked || maxWorkspaceCount.length === 0) {
    return spacesCount.numSpaces;
  }
  for (let i = 0; i < maxWorkspaceCount.length; i++) {
    const [value] = maxWorkspaceCount[i];
    if (spacesCount[value] > maxValue) {
      maxValue = spacesCount[value];
    }
  }

  return maxValue;
};

export const switches = {
  privateOfficeCount: 'private_offices',
  deskCount: 'desks',
  // meetingRoomCount: 'meeting_rooms',
  virtualOfficeCount: 'virtual_offices',
  loungeCount: 'airport_lounges',
};